import { useGet } from 'hooks/useGet';
import { Employee } from 'types';

export const useContact = (id: string) => {
  return useGet<Employee | null>(`/employees/${id}/`, [id]);
};
